module.exports = __webpack_public_path__ + "img/rating-2.bf4c8b9a.png";